import axios from "axios";

export default {
  namespaced: true,
  state: {
    itemcategories: [],
    images: [],
    isReceiving: false,
    isUpdating: false,
    isDeleting: false,
    idToDelete: null,
    itemcategoriesMessage: ''
  },
  mutations: {
    RECEIVED_CATEGORIES(state, payload) {
      state.itemcategories = payload;
      state.isReceiving = false;
    },
    RECEIVING_CATEGORIES(state) {
      state.isReceiving = true;
    },
    RECEIVED_CATEGORY(state, payload) {
      console.log("RECEIVED CATEGORY", payload);
      state = Object.assign(state, {
        itemcategories: [...state.itemcategories, payload],
        isReceiving: false,
      })
    },
    RECEIVING_CATEGORY(state) {
      state.isReceiving = true;
    },
    UPDATED_CATEGORY(state, payload) {
      console.log(state.itemcategories);
      console.log(payload);
      let index = state.itemcategories.findIndex(itemcategory => itemcategory._id === payload._id);
      state = Object.assign(state, {
        itemcategories: state.itemcategories.map((itemcategory, i) => {
          if (i === index) {
            return Object.assign({}, itemcategory, payload);
          }
          return itemcategory;
        }),
        isUpdating: false,
        itemcategoriesMessage: 'ItemCategories has been updating!',
      })
    },
    UPDATING_CATEGORY(state) {
      state.isUpdating = true;
    },
    DELETED_CATEGORY(state, payload) {
      let indexToDelete = state.itemcategories.findIndex(itemcategory => itemcategory._id === payload._id);
      console.log(indexToDelete);
      let itemcategories = [...state.itemcategories];
      itemcategories.splice(indexToDelete, 1);
      state = Object.assign(state, {
        itemcategories: [...itemcategories],
        isDeleting: false,
        idToDelete: null,
        itemcategoriesMessage: 'ItemCategory has been Deleted!',
      });
    },
    DELETING_CATEGORY(state, payload) {
      state.isDeleting = true;
      state.idToDelete = payload.id;
    },
  },
  actions: {
    getItemCategoriesRequest({dispatch}) {
      dispatch("receivingItemCategories");
      var token = localStorage.getItem('token');
      var url = 'https://api.accountxc.com:3100/get/itemcategories';
      var header = {
        'Content-Type': 'application/json',
        'Authorization': 'Bearer ' + token
      };
      var get = {
        method: "get",
        url: url,
        headers: header,
      };
      axios(get).then(res => {
        console.log("HERE", res.data);
        dispatch("receiveItemCategories", res.data);
      })
    },
    loadItemCategoryRequest({dispatch}, id) {
      dispatch("receivingItemCategory");
      axios.get('/itemcategories/' + id).then(res => {
        dispatch("receiveItemCategory", res.data);
      })
    },
    updateItemCategoryRequest({dispatch}, payload) {
      dispatch("updatingItemCategory");
      var id = payload._id;
      delete payload['_id'];
      console.log(id, payload);


      var token = localStorage.getItem('token');
      var url = 'https://api.accountxc.com:3100/update/itemcategory/' + id;
      var header = {
        'Content-Type': 'application/json',
        'Authorization': 'Bearer ' + token
      };
      var post = {
        method: "post",
        url: url,
        headers: header,
        data: payload,
      };

      axios(post)
      .then(function (res) {
        console.log(res);
        dispatch("updateItemCategory", res.data);
      })
      .catch((error) => {
        console.error('Error:', error);
        this.alertmessage = error;
      });
    },
    updateItemCategoryImageRequest({dispatch}, payload) {
      dispatch("updatingItemCategory");
      var data;
      var header;
      var token = localStorage.getItem('token');
      var id = payload._id;
      delete payload['_id'];
      console.log(id, payload);

      var url = 'https://api.accountxc.com:3100/update/itemcategory/image/' + id;
      data = new FormData();
      data.append('image', payload.itemcategoryimage, payload.imagename); 
      delete payload['itemcategoryimage'];
      for (let x in payload) {
        data.append(x, payload[x]);
      }
      header = {
        'Content-Type': 'multipart/form-data',
        'Authorization': 'Bearer ' + token
      };

      let put = {
        method: "put",
        url: url,
        headers: header,
        data: data,
      };

      axios(put)
      .then(function (res) {
        dispatch("updateItemCategory", res.data);
      })
      .catch((error) => {
        console.error('Error:', error);
        this.alertmessage = error;
      });
    },
    createItemCategoryRequest({dispatch}, payload) {
      dispatch("receivingItemCategories");
      var url;
      var data;
      var header;
      var token = localStorage.getItem('token');

      if(payload.itemcategoryimage !== undefined) {
        url = 'https://api.accountxc.com:3100/insert/itemcategory/withimage';
        data = new FormData();
        data.append('image', payload.itemcategoryimage, payload.imagename); 
        delete payload['itemcategoryimage'];
        for (let x in payload) {
          data.append(x, payload[x]);
        }
        header = {
          'Content-Type': 'multipart/form-data',
          'Authorization': 'Bearer ' + token
        };
      } else {
        url = 'https://api.accountxc.com:3100/insert/itemcategory';
        data = payload;
        header = {
          'Content-Type': 'application/json',
          'Authorization': 'Bearer ' + token
        };
      }
      var post = {
        method: "post",
        url: url,
        headers: header,
        data: data,
      };
      axios(post)
      .then(function (res) {
        console.log(res);
        dispatch("receiveItemCategory", res.data);
      })
      .catch((error) => {
        console.error('Error:', error);
        this.alertmessage = error;
      });	
    },
    deleteItemCategoryRequest({dispatch}, payload) {
      dispatch("deletingItemCategory", payload);
      console.log(payload);
      axios.get('https://api.accountxc.com:3100/delete/itemcategory/' + payload._id).then(() => {
        dispatch("deleteItemCategory", {_id: payload._id});
      })
    },
    receiveItemCategories({commit}, payload) {
      commit("RECEIVED_CATEGORIES", payload)
    },
    receivingItemCategories({commit}) {
      commit("RECEIVING_CATEGORIES")
    },
    receiveItemCategory({commit}, payload) {
      console.log("HERE");
      console.log(payload);
      commit("RECEIVED_CATEGORY", payload)
    },
    receivingItemCategory({commit}) {
      commit("RECEIVING_CATEGORY")
    },
    updateItemCategory({commit}, payload) {
      commit("UPDATED_CATEGORY", payload)
    },
    updatingItemCategory({commit}) {
      commit("UPDATING_CATEGORY")
    },
    deleteItemCategory({commit}, payload) {
      commit("DELETED_CATEGORY", payload)
    },
    deletingItemCategory({commit}, payload) {
      commit("DELETING_CATEGORY", payload)
    }
  },
};
